import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupNetboxGroup } from "./netbox";

const NetBoxSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const NetBoxSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const netboxScanners = (): Section => {
  const netboxScanners = new Section("netbox_scanner", [
    new Translation("en", "NetBox Scanners"),
    new Translation("en", "NetBox-Scanner"),
  ]);
  netboxScanners.help = [
    new Translation(
      "en",
      `Add NetBox to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie NetBox hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];
  netboxScanners.description = [
    new Translation("en", NetBoxSetupEn),
    new Translation("de", NetBoxSetupDe),
  ];

  setupNetboxGroup(netboxScanners, 0);
  return netboxScanners;
};
